import { useContext } from 'react';
import { useFormik } from 'formik';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import {
  DialogTitle,
  DialogContent,
  DialogActions,
  ModalColumna,
} from './usuariosComponents';
import { BsTrash } from 'react-icons/bs';
import Dialog from '@mui/material/Dialog';
import { validationSchema } from './validation';
import { UserContext } from '../../context/UserContext';
import { makeStyles } from '@mui/styles';
import { NativeSelect } from '@mui/material';
import InputLabel from '@mui/material/InputLabel';
import FormControl from '@mui/material/FormControl';
import Divider from '@mui/material/Divider';
import PropTypes from 'prop-types';
import { SNACKBAR_SEVERITY } from '../../constants';
import { AdminContext } from '../../context/AdminContext';

const useStyles = makeStyles((theme) => ({
  form: {
    display: 'flex',
    flexDirection: 'column',
    margin: 'auto',
    width: 'fit-content',
  },
  selectEmpty: {
    marginTop: theme.spacing(2),
  },
  formControl: {
    marginTop: theme.spacing(2),
    minWidth: 300,
  },
  formControlLabel: {
    marginTop: theme.spacing(1),
  },
  dividerFullWidth: {
    margin: `30px 0 0 0`,
  },
}));

function ModalUsuario({ modal, toggleModal, userSelection }) {
  const classes = useStyles();

  const { createUser, updateUser, deleteUser } = useContext(UserContext);
  const { handleClickSnackbar } = useContext(AdminContext);
  const initialValues = userSelection
    ? {
      id: userSelection.id,
      nombreCompleto: userSelection.nombreCompleto,
      telefono: userSelection.telefono,
      dni: userSelection.dni,
      email: userSelection.email,
      preferenciaPago: userSelection.preferenciaPago,
      calle: userSelection.calle,
      numero: userSelection.numero,
      dpto: userSelection.dpto,
      referencias: userSelection.referencias,
    }
    : {
      nombreCompleto: '',
      direccion: '',
      telefono: '',
      dni: '',
      preferenciaPago: 'NINGUNA',
      email: '',
      calle: '',
      numero: '',
      dpto: '',
      referencias: '',
    };


  const submitUser = async (values) => {
    // mensaje y tipo para el snackbar
    let mensaje = '';
    let tipo = 'error';
    // Crear usuario
    if (!userSelection) {
      const exito = await createUser(values);
      if (exito) {
        mensaje = `Usuario ${values.nombreCompleto} creado con exito`;
        tipo = 'success';
      } else {
        mensaje = `No se pudo crear el usuario`;
      }
    }
    // Actualizar usuario
    if (userSelection) {
      const exito = await updateUser({ ...userSelection, ...values });
      if (exito) {
        mensaje = `Usuario ${values.nombreCompleto} actualizado con exito`;
        tipo = 'success';
      } else {
        mensaje = `No se pudo actualizar el usuario`;
      }
    }
    formik.resetForm({
      values: {
        nombreCompleto: '',
        telefono: '',
        dni: '',
        email: '',
        calle: '',
        numero: '',
        dpto: '',
        referencias: '',
        preferenciaPago: 'NINGUNA',
      },
    });
    toggleModal(mensaje, tipo);
  }

  const formik = useFormik({
    initialValues,
    validationSchema: validationSchema,
    onSubmit: submitUser,
    enableReinitialize: true,
  });

  const eliminar = async (row) => {
    if (window.confirm(`Seguro que desea eliminar ${row.nombreCompleto} `)) {
      const exito = await deleteUser(row._id);
      if (exito) handleClickSnackbar(`usuario ${row.nombreCompleto} borrado con exito`, SNACKBAR_SEVERITY.info);
      else handleClickSnackbar(`No se pudo eliminar el usuario`, SNACKBAR_SEVERITY.error);
    }
  }

  const handleClose = () => {
    formik.resetForm();
    toggleModal();
  };

  return (
    <div>
      <Dialog
        onClose={handleClose}
        aria-labelledby='customized-dialog-title'
        open={modal}
        maxWidth='xl'>
        <form onSubmit={formik.handleSubmit} className={classes.form}>
          <DialogTitle id='customized-dialog-title' onClose={handleClose}>
            Agregar usuario
          </DialogTitle>

          <DialogContent dividers>
            <Typography gutterBottom variant='body1'>
              Datos Filiales
            </Typography>
            <Typography color='textSecondary' variant='body2'>
              (*) Son datos obligatorios
            </Typography>

            <ModalColumna>
              <TextField
                variant="standard"
                id='nombreCompleto'
                required
                name='nombreCompleto'
                error={
                  formik.touched.nombreCompleto &&
                  Boolean(formik.errors.nombreCompleto)
                }
                helperText={
                  formik.touched.nombreCompleto && formik.errors.nombreCompleto
                }
                label='Apellido y Nombre'
                value={formik.values.nombreCompleto}
                onChange={formik.handleChange} />
              <TextField
                variant="standard"
                id='dni'
                name='dni'
                label='DNI'
                value={formik.values.dni}
                onChange={formik.handleChange}
                error={formik.touched.dni && Boolean(formik.errors.dni)}
                helperText={formik.touched.dni && formik.errors.dni} />
              <TextField
                variant="standard"
                id='telefono'
                name='telefono'
                label='Telefono'
                value={formik.values.telefono}
                onChange={formik.handleChange}
                error={
                  formik.touched.telefono && Boolean(formik.errors.telefono)
                }
                helperText={formik.touched.telefono && formik.errors.telefono} />

              <TextField
                variant="standard"
                id='email'
                name='email'
                label='Email'
                value={formik.values.email}
                onChange={formik.handleChange}
                error={formik.touched.email && Boolean(formik.errors.email)}
                helperText={formik.touched.email && formik.errors.email} />

              <FormControl variant="standard" className={classes.formControl}>
                <InputLabel htmlFor='preferenciaPago'>
                  Preferencia de pago
                </InputLabel>
                <NativeSelect
                  value={formik.values.preferenciaPago}
                  onChange={formik.handleChange}
                  required
                  inputProps={{
                    name: 'preferenciaPago',
                    id: 'preferenciaPago',
                  }}
                  error={
                    formik.touched.preferenciaPago &&
                    Boolean(formik.errors.preferenciaPago)
                  }
                  helperText={
                    formik.touched.preferenciaPago &&
                    formik.errors.preferenciaPago
                  }>
                  <option aria-label='NINGUNA' value='NINGUNA'>
                    NINGUNA
                  </option>
                  <option value={'CREDITO'}>CREDITO</option>
                  <option value={'EFECTIVO'}>EFECTIVO</option>
                </NativeSelect>
              </FormControl>
            </ModalColumna>
            <Divider className={classes.dividerFullWidth} />
            <Typography className={classes.dividerFullWidth}>
              Direccion
            </Typography>

            <TextField
              variant="standard"
              fullWidth
              id='calle'
              name='calle'
              error={formik.touched.calle && Boolean(formik.errors.calle)}
              helperText={formik.touched.calle && formik.errors.calle}
              label='Calle'
              value={formik.values.calle}
              onChange={formik.handleChange} />
            <TextField
              variant="standard"
              fullWidth
              id='numero'
              name='numero'
              label='Numero'
              error={formik.touched.numero && Boolean(formik.errors.numero)}
              helperText={formik.touched.numero && formik.errors.numero}
              value={formik.values.numero}
              onChange={formik.handleChange} />
            <TextField
              variant="standard"
              fullWidth
              id='dpto'
              name='dpto'
              label='Dpto.'
              value={formik.values.dpto}
              onChange={formik.handleChange}
              error={formik.touched.dpto && Boolean(formik.errors.dpto)}
              helperText={formik.touched.dpto && formik.errors.dpto} />
            <TextField
              variant="standard"
              fullWidth
              id='referencias'
              name='referencias'
              label='Referencias'
              value={formik.values.referencias}
              onChange={formik.handleChange}
              error={
                formik.touched.referencias && Boolean(formik.errors.referencias)
              }
              helperText={
                formik.touched.referencias && formik.errors.referencias
              } />
          </DialogContent>
          <DialogActions style={{flex: "row", justifyContent: 'space-between'}}>
            {userSelection ? (
              <BsTrash
                size='1.2rem'
                onClick={() => {
                  eliminar(userSelection);
                  handleClose();
                }}
                title='Borrar'
                cursor='pointer'
              />
            ) : null}
            <Button color='primary' variant='contained' type='submit'>
              {userSelection ? 'Modificar' : 'Agregar'}
            </Button>
          </DialogActions>
        </form>
      </Dialog>
    </div>
  );
}

ModalUsuario.propTypes = {
  modal: PropTypes.bool.isRequired,
  toggleModal: PropTypes.func,
  userSelection: PropTypes.object,
  eliminarUsuario: PropTypes.func,
};

export default ModalUsuario;
